import { ControlledCheckbox } from 'components/shared/ControlledFields';
import { useTranslation } from 'react-i18next';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import { useSaveResource } from 'RestAPIs/useSaveResource';
import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { useFormContext } from 'react-hook-form';
import { SSOSettingsSchema } from '../utils';
import { GROUP_NAME_SSO } from '../usePwdUserSettingsMultipleEndpoint';
import { ssoFormData, TabProps } from '../types';
import {
  transformAdminSettingsToFormValues,
  transformAdminSettingsToRequestValues
} from '../../../../utils';
import { getSysAdminSync } from 'RestAPIs/admin';
import { showErrorSnackbar } from 'components/shared/Snackbar';
import { showSnackbar } from 'components/shared/index';

export const SSOSettings = ({ userAndPwdSettings }: TabProps) => {
  const isSysAdmin = sessionStorage.getItem('employee.id');
  const { isLoading, mutate: save } = useSaveResource({
    url: ADMIN_SETTINGS_GROUP,
    id: userAndPwdSettings.ssoSettings[0].groupId,
    invalidateQueryKey: [GROUP_NAME_SSO]
  });

  const { t } = useTranslation('common', { keyPrefix: 'userAndPassword' });

  const onSubmit = (data: ssoFormData) => {
    const payload = {
      ...userAndPwdSettings.ssoSettings[0],
      settings: transformAdminSettingsToRequestValues(
        data,
        userAndPwdSettings.ssoSettings[0].settings
      )
    };
    save(payload);
  };

  const handleSys = () => {
    getSysAdminSync()
      .then(() =>
        showSnackbar({ severity: 'success', message: t('upload_success_msg') })
      )
      .catch(() => showErrorSnackbar(t('upload_failure_msg')));
  };

  return (
    <AdminSettingsFormWrapper
      isFetching={false}
      submitForm={onSubmit}
      handleSys={() => (isSysAdmin ? handleSys : null)}
      data={transformAdminSettingsToFormValues(
        userAndPwdSettings.ssoSettings[0]
      )}
      isLoading={isLoading}
      schema={SSOSettingsSchema}
    >
      <FormFields />
    </AdminSettingsFormWrapper>
  );
};

const FormFields = () => {
  const { t } = useTranslation('common', { keyPrefix: 'userAndPassword' });
  const { control } = useFormContext();

  return (
    <>
      <ControlledCheckbox
        control={control}
        name="saml_idp_use-identity"
        label={t('useSDBIdentity')}
      />
      <ControlledCheckbox
        control={control}
        name="identity_use-oidc"
        label={t('useOIDC')}
      />
      <ControlledCheckbox
        control={control}
        name="account_edit_accountName_disable"
        label={t('disableAccountNameEditing')}
      />
      <ControlledCheckbox
        control={control}
        name="account_edit_comEmail_disable"
        label={t('disableAccountEmailEditing')}
      />
      <ControlledCheckbox
        control={control}
        name="identity-disable-local-login"
        label={t('disableLocalLogin')}
      />
    </>
  );
};
